export const DARYLS_EASTEREGG = 'DARYLS_EASTEREGG';
